// Header is position:fixed always (see _header.scss/header.php's top
// comments for why - it used to switch between relative/absolute/fixed by
// scroll position, but combining that position-type jump with this same
// transform slide was the actual cause of a visible glitch; not switching
// position at all fixes it at the root instead of patching the sequencing).
// So this file has exactly one job: toggle site-header--hidden
// (transform:translateY(-100%)) by scroll direction - up reveals it (so nav
// is reachable without scrolling back to the top), down hides it.
$(() => {
    const $header = $('#masthead');

    if (! $header.length) {
        return;
    }

    const MIN_DELTA = 5; // px - real wheel/trackpad scrolling isn't perfectly
    // monotonic even while going "one direction" overall; without this
    // deadzone, tiny reverse deltas flip the class (and retrigger the slide
    // transition) on nearly every scroll tick instead of once per real
    // direction change.

    let lastScrollY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
        const currentScrollY = Math.max(0, window.scrollY);
        const delta = currentScrollY - lastScrollY;
        const headerHeight = $header.outerHeight();

        // Past its own height it's no longer sitting over the page's own
        // hero photo (that's scrolled away too) - solid white background
        // instead of the transparent hero-overlay/dark-relative look, same
        // regardless of hide/show state so it's not just white for the
        // instant it reappears. Background-only, not position - no repeat
        // of the earlier glitch.
        $header.toggleClass('site-header--scrolled', currentScrollY > headerHeight);

        if (Math.abs(delta) > MIN_DELTA) {
            // Never hidden near the very top - nothing above to reveal by
            // scrolling up if it's already fully in view there.
            const hidden = delta > 0 && currentScrollY > headerHeight;
            $header.toggleClass('site-header--hidden', hidden);
            lastScrollY = currentScrollY;
        }

        ticking = false;
    };

    window.addEventListener('scroll', () => {
        if (! ticking) {
            requestAnimationFrame(onScroll);
            ticking = true;
        }
    }, { passive: true });

    // Mobile nav dropdown (#site-header-nav, Bootstrap's own .collapse -
    // data-bs-toggle in header.php) can scroll internally once its content
    // is taller than the viewport (see _header.scss's max-height/overflow-y
    // on .site-header__right). Without this, scrolling it to the bottom then
    // chains straight into the page behind - lock body scroll for as long as
    // the dropdown is open instead.
    $('#site-header-nav')
        .on('show.bs.collapse', () => $('body').addClass('mobile-nav-open'))
        .on('hidden.bs.collapse', () => $('body').removeClass('mobile-nav-open'));
});
